import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

interface AnnouncementsState {
  dismissedIds: string[];
}

const initialState: AnnouncementsState = {
  dismissedIds: [],
};

const announcementsSlice = createSlice({
  name: 'announcements',
  initialState,
  reducers: {
    dismissAnnouncement(state, action: PayloadAction<string>) {
      if (!state.dismissedIds.includes(action.payload)) {
        state.dismissedIds.push(action.payload);
      }
    },
    clearDismissedAnnouncements(state) {
      state.dismissedIds = [];
    },
  },
});

export const { dismissAnnouncement, clearDismissedAnnouncements } = announcementsSlice.actions;

export const selectDismissedAnnouncementIds = (state: RootState) =>
  state.announcements.dismissedIds;

export default announcementsSlice.reducer;
